import { components } from 'react-select';
import ColorConstants from '../../../shared/constants/ColorConstants';

export const SelectMenu = components.Menu;

export const SelectMenuStyles = styles => ({
    ...styles,
    border: `1px solid ${ColorConstants['catskill-white']}`,
    borderRadius: '6px',
    backgroundColor: ColorConstants.white,
    boxShadow: '0px 4px 8px #0000001A',
});
